import React from "react";
import { Container, Nav, Navbar} from "react-bootstrap";
// import Particles from "react-particles-js";
import { NavLink } from "react-router-dom";
import "./Header.css";
import resume from "../../../images/FrontendDev-ResumeRiaz.pdf";

// import Particles from "react-particles-js";

const Header = () => {
  return (
    <div className="header-nav">
      <Navbar
        collapseOnSelect
        expand="lg"
        bg="dark"
        variant="dark"
        className="text-center"
      >
        <Container>
          {/* <img
            className="my-photo"
            src="https://i.ibb.co/WG6V4Zz/hdrIMG.png"
            
            alt="img"
          />{" "} */}
          <h3 className="my-name">Iasir Arafat Riaz </h3>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="m-auto">
              <Navbar.Brand>
                <NavLink
                  to="/Home"
                  style={({ isActive }) => ({
                    color: isActive ? "crimson" : "beige",
                  })}
                >
                  <b>Home</b>
                </NavLink>
              </Navbar.Brand>

              <Navbar.Brand>
                {""}
                <NavLink to="/Projects"   style={({ isActive }) => ({
                    color: isActive ? "crimson" : "beige",
                  })}>
                  <b>Projects</b>
                </NavLink>
              </Navbar.Brand>

              <Navbar.Brand>
                {" "}
                <NavLink to="/About"   style={({ isActive }) => ({
                    color: isActive ? "crimson" : "beige",
                  })}>
                  <b>About Me</b>
                </NavLink>
              </Navbar.Brand>

              <Navbar.Brand>
                {" "}
                <NavLink to="/Contact"   style={({ isActive }) => ({
                    color: isActive ? "crimson" : "beige",
                  })}>
                  <b>Contact </b>
                </NavLink>
              </Navbar.Brand>

              <Navbar.Brand>
                {" "}
                <NavLink to="/Blogs"   style={({ isActive }) => ({
                    color: isActive ? "crimson" : "beige",
                  })}>
                  <b>Blogs </b>
                </NavLink>
              </Navbar.Brand>
            </Nav>
          </Navbar.Collapse>
          <a id="resume-download" download="DeveloperRiaz-Resume" href={resume}>
            <b>Get Resume</b>
          </a>
        </Container>
      </Navbar>
    </div>
  );
};

export default Header;
